<template>
  <v-container>
    <v-row class="justify-end align-center">
      <v-col cols="12" md="auto" class="d-flex justify-center align-center">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="auto" class="d-flex justify-center align-center">
        <v-btn
          @click="openForm()"
          color="success"
          style="min-width:150px"
          rounded
        >
          Crear registro
        </v-btn>
      </v-col>

      <v-col cols="12" md="auto" class="d-flex justify-center align-center">
        <v-btn
          @click="openRecycle"
          color="primary"
          style="min-width:150px"
          rounded
          outlined
        >
          Reciclar
        </v-btn>
      </v-col>

      <v-col cols="12" md="auto" class="d-flex justify-center align-center">
        <v-btn
          @click="openReasign"
          color="primary"
          style="min-width:150px"
          rounded
          outlined
        >
          Reasignar
        </v-btn>
      </v-col>

      <v-col cols="auto" class="mr-auto">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="openImportData"
              v-bind="attrs"
              v-on="on"
              color="info"
              small
              rounded
              fab
            >
              <v-icon>
                mdi-upload
              </v-icon>
            </v-btn>
          </template>
          <span>Importar</span>
        </v-tooltip>
      </v-col>
      <v-col cols="auto" class="ml-auto">

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab small color="success" v-bind="attrs" v-on="on">
              <v-icon>
                mdi-download
              </v-icon>
              <!-- Descargar -->
            </v-btn>
          </template>
          <v-list>
            <v-list-item link href="/assets/FormatoPlantillaSinAsignacion.xlsx">
              <v-list-item-title>
                Descargar plantilla
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="downloadCsv()">
              <v-list-item-title>
                Descargar registro
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col cols="auto">
        <v-switch v-model="activeGraph" inset label="Ver gráficas"></v-switch>
      </v-col>
    </v-row>
    <!-- Resumen de la Marcacion -->
    <v-row justify="center">
      <v-col cols="8">
        <h5>Resumen de la Marcación</h5>
      </v-col>
      <v-col cols="8">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left font-weight-bold">
                  Estado
                </th>
                <th class="text-left font-weight-bold">
                  Total
                </th>
                <th class="text-left font-weight-bold">
                  &nbsp;
                </th>
              </tr>
            </thead>
            <tbody v-if="registerList.length > 0">
              <tr v-for="item in registerList" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.register_count }}</td>
                <td>
                  <v-btn @click="getRegisterItems(item.id)" rounded icon>
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="item in statusList" :key="item.id">
                <td>{{ item.name }}</td>
                <td>0</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-container v-show="!activeGraph">
      <h5>Base de Datos</h5>
      <v-data-table
        :loading="isLoading"
        :headers="dataBaseTableHeaders"
        :items="registerItems"
        :server-items-length="dataBaseTotal"
        :options.sync="dataBaseOptions"
      >
        <template v-slot:[`item.type`]="{ item }">
          {{ campaignTypes.find((el) => el.id === item.campaign_type_id).name }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <!-- Edit -->
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="openForm(true, item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>
          <!-- Delete -->
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'error' : 'blue-grey'"
              @click.stop="deleteAction(item.id)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-container>

    <!-- Gráficas -->
    <v-container v-if="activeGraph" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="5" v-if="render && activeGraphDonut">
          <v-card outlined style="height: inehit;">
            <!-- <v-card-title
                            class="title text--primary"
                            style="word-break: normal; line-height: normal;"
                        >
                            Porcentaje de llamadas
                        </v-card-title> -->
            <v-card-text>
              <apexchart
                ref="chart5"
                type="donut"
                :options="optionsDonut"
                :series="serieDonut"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-else-if="!render && !activeGraphDonut" cols="12" md="5">
          <v-skeleton-loader
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col v-if="render && activeGraphAgent" cols="12" md="6">
          <v-card outlined>
            <!-- <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal;"
            >
              Llamadas entrantes por extensión
            </v-card-title> -->
            <v-card-text>
              <apexchart
                ref="chart7"
                type="bar"
                :options="optionsBarAgent"
                :series="barAgents"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-else-if="!render && !activeGraphAgent" cols="12" md="6">
          <v-skeleton-loader
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col v-if="render && activeGraph3" cols="12" md="6">
          <v-card outlined>
            <!-- <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal;"
            >
              Llamadas entrantes por extensión
            </v-card-title> -->
            <v-card-text>
              <apexchart
                ref="chart3"
                type="bar"
                :options="optionsBar3"
                :series="bar3"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-else-if="!render && !activeGraph3" cols="12" md="6">
          <v-skeleton-loader
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col v-if="render && activeGraph4" cols="12" md="6">
          <v-card outlined>
            <!-- <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal;"
            >
              Llamadas entrantes por extensión
            </v-card-title> -->
            <v-card-text>
              <apexchart
                ref="chart4"
                type="bar"
                :options="optionsBar4"
                :series="bar4"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-else-if="!render && !activeGraph4" cols="12" md="6">
          <v-skeleton-loader
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>

    <create-dialog
      v-if="formDialog"
      :dialog="formDialog"
      :axios="$axios"
      :editMode="editMode"
      :data="itemToEdit"
      :statusRegisterList="statusList"
      :id="id"
      @dialog:close="callbackForm"
    ></create-dialog>
    <delete-dialog
      v-if="deleteDialog"
      :dialog="deleteDialog"
      :axios="$axios"
      :id="idToDelete"
      @dialog:close="deleteCallback"
    ></delete-dialog>
    <import-dialog
      v-if="isOpenImport"
      :isOpenDialog="isOpenImport"
      :campaignId="id"
      @dialog:close="closeImportData"
    ></import-dialog>
    <recycle-dialog
      v-if="isOpenRecycle"
      :isOpenDialog="isOpenRecycle"
      :campaignId="id"
      :statusList="statusList"
      @dialog:close="closeRecycle"
    ></recycle-dialog>
    <reasign-dialog
      v-if="isOpenReasign"
      :isOpenDialog="isOpenReasign"
      :campaignId="id"
      :oldAgent="oldAgent"
      @dialog:close="closeReasign"
    ></reasign-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
// import VueJsonToCsv from "vue-json-to-csv";
import CreateDialog from "@/components/Campaigns/CreateRegister";
import DeleteDialog from "@/components/Campaigns/DeleteRegister";
import ImportDialog from "../../components/Campaigns/ImportDialog.vue";
import CdrDownloadToCsv from "@/components/Utils/CdrDownloadCsv";
import RecycleDialog from "@/components/Campaigns/RecycleDialog";
import ReasignDialog from "@/components/Campaigns/ReasignDialog";

export default {
  props: {
    id: {
      type: String
    }
  },
  components: {
    CreateDialog,
    DeleteDialog,
    ImportDialog,
    RecycleDialog,
    ReasignDialog
    // VueJsonToCsv
  },
  data() {
    return {
      isLoading: false,
      activeGraph: false,
      render: false,
      activeGraphDonut: false,
      activeGraphAgent: false,
      activeGraph3: false,
      activeGraph4: false,
      isOpenImport: false,
      isOpenRecycle: false,
      isOpenReasign: false,
      formDialog: false,
      deleteDialog: false,
      editMode: false,
      dataBaseTotal: 0,
      csvTitle: "",
      statusList: [],
      oldAgent: null,
      registerList: [],
      registerItems: [],
      registerItemsToDownload: [],
      dataBaseTableHeaders: [
        { text: "Cod. CLiente", value: "user_id", width: "5%" },
        { text: "Nombre de cliente", value: "name", width: "15%" },
        { text: "Dni", value: "dni", width: "10%" },
        { text: "Telefono 1", value: "telefono1", width: "15%" },
        { text: "Estado", value: "status.name", width: "15%" },
        { text: "Agente", value: "user.name", width: "10%" },
        { text: "Ultima modif.", value: "updated_at", width: "15%" },
        { text: "Acciones", value: "action", width: "10%" }
      ],
      itemToEdit: null,
      idToDelete: null,
      idRegisterSelected: null,
      $axios: null,
      dataBaseOptions: {},
      campaignInfo: {},
      // Opciones chart
      optionsLine: {
        stroke: {
          curve: "smooth"
        },
        xaxis: {
          categories: []
        }
      },
      optionsDonut: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%"
              }
            }
          }
        ],
        width: "100%",
        legend: {
          position: "bottom"
        },
        labels: ["Activa", "Ocupado"]
      },
      optionsBarAgent: {
        xaxis: {
          categories: []
        },
        fill: {
          colors: ["#6D71F9"]
        }
      },
      optionsBar3: {
        xaxis: {
          categories: []
        },
        fill: {
          colors: ["#6D71F9"]
        }
      },
      optionsBar4: {
        chart: {
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10
          }
        },
        xaxis: {
          categories: []
        }
      },
      optionsBarOutgoingCalls: {
        xaxis: {
          categories: []
        }
        // fill: {
        //     colors: ["#625FA4"]
        // },
      },
      // Datos chart
      serieDonut: [0, 0],
      barAgents: [
        {
          name: "Agentes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],
      bar3: [
        {
          name: "Acumulado de registro por hora",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],
      bar4: []
    };
  },

  watch: {
    dataBaseOptions: {
      handler() {
        if (this.idRegisterSelected)
          this.getRegisterItems(this.idRegisterSelected);
      },
      deep: true
    },
    activeGraph(val) {
      if (val == true) {
        this.getGraphicsValues();
      }
    }
  },

  created() {
    const token = localStorage.getItem("token");
    this.$axios = axios.create({
      baseURL: process.env.VUE_APP_ROOTAPI,
      headers: { Authorization: `Bearer ${token}` }
    });
    this.getStatusRegister();
    this.getCampaignRegister();
    this.getCampaignInfo();
  },

  beforeDestroy() {
    this.$store.commit("layout/CLEAR_TITLE");
  },

  methods: {
    async downloadCsv() {
      const payload = { campaign_id: this.id };
      try {
        await CdrDownloadToCsv(payload, "CampaignDetails");
      } catch (err) {
        // console.log(err);
        this.$snotify.error(
          "No se pudo descargar los registros seleccionados.",
          "¡Error!"
        );
      }
    },

    async getGraphicsValues() {
      try {
        const { data } = await this.$axios.get(`/campaign/graph/${this.id}`);

        // console.log(data);

        // Gráfica dona
        // this.optionsDonut.labels = data.pie.map(function(value) {
        //   return value.user;
        // });
        this.optionsDonut.labels = Object.keys(data.pie);
        this.serieDonut = Object.values(data.pie);
        this.activeGraphDonut = true;

        // gráfica de barra de agentes
        this.optionsBarAgent.xaxis.categories = data.barra.map(function(value) {
          return value.user;
        });
        this.barAgents[0].data = data.barra.map(function(value) {
          return value.total;
        });
        this.activeGraphAgent = true;

        // gráfica 3 de barra
        this.optionsBar3.xaxis.categories = data.graph3H;
        this.bar3[0].data = data.graph3A;
        this.activeGraph3 = true;

        // gráfica 4 de barra
        this.optionsBar4.xaxis.categories = data.graph3H;

        for (const prop in data.graph3B) {
          this.bar4.push({
            name: prop,
            data: data.graph3B[prop]
          });
        }

        this.activeGraph4 = true;

        this.render = true;
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
    },

    async getCampaignInfo() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando"
      });
      try {
        const { data } = await this.$axios.get(`/campaign/campaign/${this.id}`);
        this.campaignInfo = data;
        const newTitle = `Campaña: ${data.name} - ${data.id} - ${data.type_campaign.name}`;
        this.$store.commit("layout/SET_TITLE", newTitle);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    async getStatusRegister() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando"
      });
      try {
        const { data } = await this.$axios.get("/campaign/status_register");
        this.statusList = data;
      } catch (err) {
        console.log("error getting statusList:", err);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    async getCampaignRegister() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando"
      });
      try {
        const { data } = await this.$axios.get(
          `/campaign/base_register_state/${this.id}`
        );
        this.registerList = data;
      } catch (err) {
        console.log("error getting registers:", err);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    async getRegisterItems(stateId) {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando"
      });
      this.isLoading = true;
      this.idRegisterSelected = stateId;
      const page = this.dataBaseOptions.page || 1;
      const itemPerPage = this.dataBaseOptions.itemsPerPage || 15;
      try {
        const { data } = await this.$axios.get(
          `/campaign/register_detail/${stateId}/${this.id}`,
          {
            params: { page, itemPerPage }
          }
        );
        this.registerItems = data.data;
        this.dataBaseTotal = data.total;
        this.getTitleToCsv(stateId);
        this.formatItems();
      } catch (err) {
        console.log("error getting registers items:", err);
      }
      this.isLoading = false;
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    openForm(editMode = false, item = null) {
      this.editMode = editMode;
      if (editMode) this.itemToEdit = item;
      this.formDialog = true;
    },

    openImportData() {
      this.isOpenImport = true;
    },

    closeImportData() {
      this.isOpenImport = false;
    },
    openRecycle() {
      this.isOpenRecycle = true;
    },
    closeRecycle() {
      this.isOpenRecycle = false;
    },
    openReasign() {
      this.isOpenReasign = true;
    },
    closeReasign() {
      this.isOpenReasign = false;
    },

    callbackForm(item = null) {
      if (item && this.editMode)
        this.registerItems = this.registerItems.map((el) =>
          el.id === item.id ? item : el
        );
      this.formDialog = false;
      if (!this.editMode) {
        this.registerItems = [];
        this.getCampaignRegister();
      }
      this.editMode = false;
      // console.log("return form...");
    },

    deleteAction(id) {
      this.idToDelete = id;
      this.deleteDialog = true;
    },

    deleteCallback(id = null) {
      if (id)
        this.registerItems = this.registerItems.filter((el) => el.id !== id);
      this.deleteDialog = false;
      this.getCampaignRegister();
    },

    getTitleToCsv(id) {
      const name = this.statusList.find((el) => el.id === id)?.name;
      this.csvTitle = `Registros con Estatus: ${name}`;
    },

    formatItems() {
      this.registerItemsToDownload = this.registerItems.map((el) => ({
        Nombre: el.name,
        Dirección: el.direction,
        País: el.country,
        DNI: el.dni,
        Estatus: el.status.name,
        Campaña: el.campaign.name,
        telefono1: el.telefono1 || "",
        telefono2: el.telefono2 || "",
        telefono3: el.telefono3 || "",
        telefono4: el.telefono4 || "",
        telefono5: el.telefono5 || "",
        var1: el.var1 || "",
        var2: el.var2 || "",
        var3: el.var3 || "",
        var4: el.var4 || "",
        var5: el.var5 || "",
        var6: el.var6 || "",
        var7: el.var7 || "",
        var8: el.var8 || "",
        var9: el.var9 || "",
        var10: el.var10 || "",
        "Ultima Modificación": el.updated_at
      }));
    }
  }
};
</script>
